import { ICurrency } from '../interfaces/ICurrency';
import errorHelper from '../helpers/errors';

class Currencies {
    static GetGlobalPaymentCurrencies = (): Promise<Array<ICurrency>> => {
        return fetch('payments/currencies/global')
            .then((response) => errorHelper.handleErrors(response))
            .then((response) => response.json() as Promise<Array<ICurrency>>);
    };
}

export default Currencies;
